import Prompt from '../Prompt/Prompt';
import { data } from '../PromptSuggestions/PromptSuggestions.data';
import { Wrapper } from './PrompterGenerate.style';

export type PrompterGenerateProps = {
  isEmployee: boolean;
  mode: EditMode;
  isAiRunning: boolean;
  onPrompt: (prompt: string) => void;
  placeholder?: string;
};

const DEFAULT_PLACEHOLDER = 'Describe the object you want to spawn';

export function PrompterGenerate(props: PrompterGenerateProps) {
  const { isAiRunning, placeholder = DEFAULT_PLACEHOLDER } = props;

  return (
    <Wrapper className='PrompterGenerate-wrapper' data-testid='PrompterGenerate-wrapper'>
      <Prompt
        placeholder={placeholder}
        suggestions={data}
        onPrompt={props.onPrompt}
        ctaText='Generate Model'
        isLoading={isAiRunning}
        ctaColor='pink'
      ></Prompt>
    </Wrapper>
  );
}

export default PrompterGenerate;
